import { AlertTriangle, BookOpen, ShieldCheck } from "lucide-react";

const safeSource = (source) => {
  try {
    const url = new URL(source);
    return ["http:", "https:"].includes(url.protocol) ? source : null;
  } catch {
    return null;
  }
};

export const ChatMessage = ({ message }) => {
  const isUser = message.role === "user";
  const validSources = (message.sources || []).filter(safeSource);

  return (
    <article
      className={`chat-message chat-message--${message.role}`}
      data-testid={`${message.role}-message-${message.id}`}
    >
      {!isUser && (
        <span
          className={`chat-message__avatar ${message.redFlag ? "chat-message__avatar--warning" : ""}`}
          aria-hidden="true"
        >
          {message.redFlag ? <AlertTriangle /> : <ShieldCheck />}
        </span>
      )}

      <div
        className={`chat-bubble ${message.redFlag ? "chat-bubble--warning" : ""} ${message.isError ? "chat-bubble--error" : ""}`}
        role={message.redFlag || message.isError ? "alert" : undefined}
        data-testid={`${isUser ? "user" : "bot"}-message-bubble-${message.id}`}
      >
        <p className="chat-bubble__text">{message.content}</p>

        {validSources.length > 0 && (
          <div
            className="chat-sources"
            data-testid={`sources-section-${message.id}`}
          >
            <div className="chat-sources__label">
              <BookOpen aria-hidden="true" />
              <span>Sources</span>
            </div>
            <ol>
              {validSources.map((source, index) => (
                <li key={`${source}-${index}`}>
                  <a
                    href={source}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`source-link-${message.id}-${index}`}
                  >
                    {source}
                  </a>
                </li>
              ))}
            </ol>
          </div>
        )}
      </div>
    </article>
  );
};